// Création de l'objet à envoyer au back
const formaterCreationAdresseSecondaire = (adressesSecondaires, uuidBrouillon) => {
    return {
        uuidBrouillon,
        adressesSecondaires: JSON.stringify(adressesSecondaires) ?? null,
    };
};

export default formaterCreationAdresseSecondaire;
